import Swal from 'sweetalert2';

const state = {};

const mutations = {};

const actions = {
  success({ commit, dispatch }, message) {
    this.$app.$notify({
      timeout: 2500,
      message: message,
      horizontalAlign: 'right',
      verticalAlign: 'bottom',
      icon: 'notifications_none',
      type: 'success',
    });
  },

  error({ commit, dispatch }, message) {
    this.$app.$notify({
      timeout: 2500,
      message: message,
      horizontalAlign: 'right',
      verticalAlign: 'bottom',
      icon: 'notifications_none',
      type: 'warning',
    });
  },
};

const getters = {};

const alerts = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default alerts;
